import { render, staticRenderFns } from "./ModalEditarAlta.vue?vue&type=template&id=96ed4678&"
import script from "./ModalEditarAlta.vue?vue&type=script&lang=ts&"
export * from "./ModalEditarAlta.vue?vue&type=script&lang=ts&"
import style0 from "./ModalEditarAlta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('96ed4678', component.options)
    } else {
      api.reload('96ed4678', component.options)
    }
    module.hot.accept("./ModalEditarAlta.vue?vue&type=template&id=96ed4678&", function () {
      api.rerender('96ed4678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/AltasServicio/ModalEditarAlta.vue"
export default component.exports